export interface Series {
  id: string;
  title: string;
  category: string;
  tags: string[];
  chapters: string;
  heat: number;
  rating: string;
  group: string;
  desc: string;
  cover: string;
}

export interface UpdateItem {
  title: string;
  chapter: string;
  group: string;
  time: string;
}

export const categories = [
  { name: '奇幻冒险', icon: 'ri-sword-fill', count: 128, desc: '剑与魔法的异世界征途' },
  { name: '都市职场', icon: 'ri-building-2-fill', count: 96, desc: '都市男女的成长与抉择' },
  { name: '校园青春', icon: 'ri-graduation-cap-fill', count: 87, desc: '青春正好，梦想正燃' },
  { name: '热血动作', icon: 'ri-flashlight-fill', count: 74, desc: '拳拳到肉的硬核对决' },
  { name: '悬疑惊悚', icon: 'ri-spy-fill', count: 63, desc: '迷雾深处藏着真相' },
  { name: '穿越重生', icon: 'ri-refund-2-fill', count: 58, desc: '重来一次，扭转命运' },
  { name: '治愈日常', icon: 'ri-cup-fill', count: 49, desc: '温暖琐碎的小确幸' },
  { name: '体育竞技', icon: 'ri-medal-fill', count: 36, desc: '赛场之上的荣耀之争' },
];

export const seriesList: Series[] = [
  {
    id: 'xinggui',
    title: '星轨之约',
    category: '奇幻冒险',
    tags: ['星辰', '命运', '冒险'],
    chapters: '连载至 128话',
    heat: 98,
    rating: '9.6',
    group: '星火汉化',
    desc: '少年在陨星坠落之夜与神秘少女相遇，一场横跨星轨的宿命之旅由此展开。',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20Korean%20manhwa%20cover%20illustration%2C%20two%20young%20protagonists%20beneath%20a%20glowing%20starry%20night%20sky%20with%20a%20luminous%20celestial%20ring%2C%20deep%20navy%20and%20warm%20gold%20palette%2C%20clean%20bold%20lineart%2C%20dramatic%20backlight%2C%20high%20detail%20digital%20painting%2C%20portrait%20composition%2C%20no%20text&width=600&height=800&seq=cover-xinggui&orientation=portrait',
  },
  {
    id: 'dushi',
    title: '都市特调组',
    category: '都市职场',
    tags: ['特工', '都市', '动作'],
    chapters: '连载至 85话',
    heat: 92,
    rating: '9.2',
    group: '夜莺汉化',
    desc: '表面是普通办公室，实则是处理都市异象的秘密特调组，日常与惊险只隔一扇门。',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20Korean%20manhwa%20cover%20illustration%2C%20cool%20city%20agent%20duo%20in%20sharp%20suits%20walking%20through%20neon-lit%20rainy%20streets%20at%20night%2C%20coral%20and%20teal%20rim%20lighting%2C%20cinematic%20mood%2C%20clean%20bold%20lineart%2C%20portrait%20composition%2C%20no%20text&width=600&height=800&seq=cover-dushi&orientation=portrait',
  },
  {
    id: 'xia',
    title: '夏日篮球社',
    category: '体育竞技',
    tags: ['篮球', '社团', '青春'],
    chapters: '连载至 54话',
    heat: 88,
    rating: '8.9',
    group: '燃魂汉化',
    desc: '一支濒临解散的篮球社，一群不服输的少年，用汗水把夏天投进篮筐。',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20Korean%20manhwa%20cover%20illustration%2C%20energetic%20high%20school%20basketball%20players%20mid-dunk%20on%20a%20sunlit%20summer%20court%2C%20warm%20orange%20and%20cream%20palette%2C%20dynamic%20action%20pose%2C%20clean%20bold%20lineart%2C%20portrait%20composition%2C%20no%20text&width=600&height=800&seq=cover-xia&orientation=portrait',
  },
  {
    id: 'miwu',
    title: '迷雾侦探社',
    category: '悬疑惊悚',
    tags: ['推理', '迷雾', '悬疑'],
    chapters: '连载至 67话',
    heat: 90,
    rating: '9.1',
    group: '夜莺汉化',
    desc: '藏在小巷深处的侦探社，每一桩委托背后都藏着一道让人头皮发麻的谜题。',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20Korean%20manhwa%20cover%20illustration%2C%20young%20detective%20holding%20a%20magnifying%20glass%20in%20a%20foggy%20noir%20alley%2C%20muted%20teal%20and%20amber%20tones%2C%20mysterious%20atmosphere%2C%20clean%20bold%20lineart%2C%20portrait%20composition%2C%20no%20text&width=600&height=800&seq=cover-miwu&orientation=portrait',
  },
  {
    id: 'yuexia',
    title: '月下料理师',
    category: '治愈日常',
    tags: ['美食', '治愈', '温馨'],
    chapters: '连载至 41话',
    heat: 85,
    rating: '9.0',
    group: '暖光汉化',
    desc: '只在月圆之夜开门的深夜小馆，一道道暖心料理，治愈每一个疲惫的灵魂。',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20Korean%20manhwa%20cover%20illustration%2C%20warm%20cozy%20night%20kitchen%20under%20a%20big%20full%20moon%2C%20chef%20plating%20a%20glowing%20dish%2C%20golden%20lantern%20light%2C%20gentle%20wholesome%20mood%2C%20clean%20bold%20lineart%2C%20portrait%20composition%2C%20no%20text&width=600&height=800&seq=cover-yuexia&orientation=portrait',
  },
  {
    id: 'chongsheng',
    title: '重生之王者',
    category: '穿越重生',
    tags: ['重生', '权谋', '逆袭'],
    chapters: '连载至 76话',
    heat: 95,
    rating: '9.5',
    group: '星火汉化',
    desc: '含冤而终的废太子重生于登基前夜，这一次，他要把属于自己的一切夺回来。',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20Korean%20manhwa%20cover%20illustration%2C%20a%20determined%20young%20king%20with%20a%20glowing%20crown%20standing%20before%20a%20grand%20castle%2C%20royal%20crimson%20and%20gold%20palette%2C%20epic%20fantasy%2C%20dramatic%20lighting%2C%20clean%20bold%20lineart%2C%20portrait%20composition%2C%20no%20text&width=600&height=800&seq=cover-chongsheng&orientation=portrait',
  },
  {
    id: 'wangpai',
    title: '王牌高校',
    category: '校园青春',
    tags: ['校园', '社团', '热血'],
    chapters: '连载至 102话',
    heat: 91,
    rating: '9.2',
    group: '燃魂汉化',
    desc: '全校闻名的"吊车尾"班级，靠着不服输的劲头，一步步冲向学园祭之巅。',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20Korean%20manhwa%20cover%20illustration%2C%20cheerful%20high%20school%20friends%20in%20summer%20uniform%20laughing%20on%20a%20bright%20campus%20rooftop%2C%20vivid%20coral%20and%20sky%20tones%2C%20youthful%20energy%2C%20clean%20bold%20lineart%2C%20portrait%20composition%2C%20no%20text&width=600&height=800&seq=cover-wangpai&orientation=portrait',
  },
  {
    id: 'longji',
    title: '龙脊传说',
    category: '奇幻冒险',
    tags: ['巨龙', '史诗', '冒险'],
    chapters: '连载至 93话',
    heat: 93,
    rating: '9.4',
    group: '暖光汉化',
    desc: '当沉睡于龙脊山脉的巨龙苏醒，一个无名少年被命运推上拯救大陆的征程。',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20Korean%20manhwa%20cover%20illustration%2C%20a%20young%20warrior%20facing%20a%20colossal%20dragon%20across%20a%20misty%20mountain%20ridge%2C%20emerald%20and%20amber%20palette%2C%20epic%20scale%2C%20dramatic%20clouds%2C%20clean%20bold%20lineart%2C%20portrait%20composition%2C%20no%20text&width=600&height=800&seq=cover-longji&orientation=portrait',
  },
  {
    id: 'xingchen',
    title: '星辰记事',
    category: '治愈日常',
    tags: ['日常', '治愈', '生活'],
    chapters: '连载至 38话',
    heat: 82,
    rating: '8.8',
    group: '暖光汉化',
    desc: '一对青梅竹马在平凡小镇里，把一年四季过成一本温柔的手账。',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20Korean%20manhwa%20cover%20illustration%2C%20two%20childhood%20friends%20walking%20through%20a%20small%20quiet%20town%20with%20warm%20afternoon%20light%2C%20soft%20cream%20and%20peach%20palette%2C%20gentle%20slice%20of%20life%2C%20clean%20bold%20lineart%2C%20portrait%20composition%2C%20no%20text&width=600&height=800&seq=cover-xingchen&orientation=portrait',
  },
  {
    id: 'tianqi',
    title: '天启骑士',
    category: '热血动作',
    tags: ['骑士', '战斗', '热血'],
    chapters: '连载至 118话',
    heat: 96,
    rating: '9.6',
    group: '星火汉化',
    desc: '身负天启印记的落魄骑士，在乱世中以一人一剑，开辟属于自己的骑士传说。',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20Korean%20manhwa%20cover%20illustration%2C%20a%20lone%20knight%20in%20battered%20armor%20gripping%20a%20glowing%20sword%20on%20a%20battlefield%20at%20dusk%2C%20crimson%20and%20gold%20light%2C%20fierce%20determined%20gaze%2C%20clean%20bold%20lineart%2C%20portrait%20composition%2C%20no%20text&width=600&height=800&seq=cover-tianqi&orientation=portrait',
  },
];

export const latestUpdates: UpdateItem[] = [
  { title: '星轨之约', chapter: '第 128 话', group: '星火汉化', time: '今天 22:30' },
  { title: '天启骑士', chapter: '第 118 话', group: '星火汉化', time: '今天 21:05' },
  { title: '王牌高校', chapter: '第 102 话', group: '燃魂汉化', time: '今天 19:40' },
  { title: '龙脊传说', chapter: '第 93 话', group: '暖光汉化', time: '今天 18:15' },
  { title: '重生之王者', chapter: '第 76 话', group: '星火汉化', time: '今天 16:50' },
  { title: '迷雾侦探社', chapter: '第 67 话', group: '夜莺汉化', time: '昨天 23:12' },
  { title: '夏日篮球社', chapter: '第 54 话', group: '燃魂汉化', time: '昨天 21:26' },
  { title: '月下料理师', chapter: '第 41 话', group: '暖光汉化', time: '昨天 19:08' },
];

export const featured = {
  title: '天启骑士',
  tagline: '编辑本周力荐',
  group: '星火汉化',
  chapters: '连载至 118话',
  rating: '9.6',
  heat: 96,
  category: '热血动作',
  intro:
    '王权崩塌的乱世里，曾经辉煌的骑士团只剩一人。落魄骑士背负着无人相信的"天启印记"，以孤剑行于废墟之间。当命运的齿轮再次转动，所有人都以为他早已坠落——而他要做的，是让整个大陆重新记起骑士之名。本期编辑力荐，热血与燃情兼具的连载佳作。',
  image: 'https://readdy.ai/api/search-image?query=Stylized%20Korean%20manhwa%20splash%20illustration%2C%20a%20heroic%20knight%20leaping%20across%20a%20fractured%20skyline%20with%20glowing%20embers%20trailing%20behind%2C%20warm%20coral%20and%20deep%20teal%20palette%2C%20dynamic%20diagonal%20composition%2C%20bold%20lineart%2C%20cinematic%20scale%2C%20no%20text&width=1200&height=640&seq=featured-banner&orientation=landscape',
};

export const testimonials = [
  {
    name: '追更中的小黎',
    role: '奇幻漫迷',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20flat%20illustration%20of%20a%20smiling%20young%20man%20with%20headphones%2C%20warm%20coral%20background%2C%20clean%20minimal%20style%2C%20no%20text&width=200&height=200&seq=avatar-1&orientation=squarish',
    content: '每天睡前刷一遍"最新更新"已经成为习惯，熟肉出得又稳又快，追更体验太舒服了。',
  },
  {
    name: '阿哲不熬夜',
    role: '热血漫迷',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20flat%20illustration%20of%20a%20cool%20young%20man%20with%20short%20hair%2C%20warm%20amber%20background%2C%20clean%20minimal%20style%2C%20no%20text&width=200&height=200&seq=avatar-2&orientation=squarish',
    content: '下拉式阅读真的比翻页爽太多了，一话刷下来一气呵成，汉化组翻得很接地气。',
  },
  {
    name: '罐装桃子',
    role: '治愈漫迷',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20flat%20illustration%20of%20a%20smiling%20young%20woman%20with%20long%20hair%2C%20warm%20peach%20background%2C%20clean%20minimal%20style%2C%20no%20text&width=200&height=200&seq=avatar-3&orientation=squarish',
    content: '分类很清晰，想看的类型都能第一时间找到，冷门好漫也能被推荐到，很惊喜。',
  },
];

export const faqs = [
  {
    q: '漫画韩国下拉式是什么？',
    a: '漫画韩国下拉式是一个专注韩国漫画（韩漫）阅读与追更的中文门户，聚合多家汉化组的熟肉更新，采用一话到底、滚动下滑的阅读形式，让你能连续看完一整话剧情而无需频繁翻页。',
  },
  {
    q: '什么是"熟肉"和"生肉"？',
    a: '"生肉"指未翻译的原始韩文版本，"熟肉"则指已经由汉化组翻译、校对完成的简体中文版本。本站的连载内容均为汉化组精心翻译的熟肉，追求准确与流畅并重。',
  },
  {
    q: '"下拉式阅读"和普通漫画阅读有什么区别？',
    a: '普通漫画通常按页左右翻看；下拉式阅读则将一整话内容纵向连续排列，手指下滑即可无缝追完一话，配合手机竖屏更沉浸，阅读节奏也更连贯。',
  },
  {
    q: '多久更新一次？怎样才能第一时间追更？',
    a: '热门连载基本保持每日更新，部分大作每周固定话数。你只需浏览"最新更新"列表即可掌握各剧的最新进度，配合收藏功能就能第一时间看到新熟肉。',
  },
  {
    q: '需要付费吗？如何支持汉化组？',
    a: '本站的熟肉连载目前免费观看，不需要付费。如果你喜欢某部作品，可以多留言鼓励、向朋友推荐，就是对汉化组最好的支持。',
  },
  {
    q: '作品会一直连载到完结吗？',
    a: '只要原作者持续更新，我们就会同步连载至完结。若遇到原作休刊或停更，会在对应连载卡片上标注状态，避免大家空等。',
  },
];

export const aboutPoints = [
  '多组汉化聚合',
  '热门作品全覆盖，多汉化组同步更新。',
  '下拉式阅读',
  '一话到底，滚动追更沉浸不打断。',
  '每日稳定更新',
  '连载进度紧跟原作，熟肉从不缺席。',
];